import styled from 'styled-components';

export const StyledModelSelectionArea = styled.div<{
  hideBottomPadding?: boolean;
}>`
  padding-bottom: ${(props) => props.theme.internal.size.static450};

  @media (max-width: ${(props) => props.theme.internal.Breakpoints.b560}px) {
    ${({hideBottomPadding}) => hideBottomPadding && 'padding-bottom: 0;'}
  }
`;
